import { useMemo } from 'react';

import { Divider, type DividerProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface SubmenuGroupDividerProps<OptionType extends CascaderOption>
  extends DividerProps {
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalSubmenuGroupDivider = <
  OptionType extends CascaderOption,
>() => {
  const { cascaderStyles, getCommonProps } = useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomSubmenuGroupDivider = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.SUBMENU_GROUP_DIVIDER),
    [getComponent],
  );

  return (
    <CustomSubmenuGroupDivider
      getCommonProps={getCommonProps}
      __css={cascaderStyles.submenuGroupDivider}
      className="cascader-submenu-group-divider"
    />
  );
};

export const SubmenuGroupDivider = <OptionType extends CascaderOption>({
  getCommonProps: _,
  ...rest
}: SubmenuGroupDividerProps<OptionType>) => {
  return <Divider {...rest} />;
};
